import { getTvObject } from '@costar-ui/cosmos';

var sizeOptions = getTvObject({
  width: {
    xs: 'w-2',
    sm: 'w-3',
    md: 'w-4',
    lg: 'w-8',
    xl: 'w-9',
    '0.25': 'w-e-0.25',
    '0.5': 'w-e-0.5',
    '0.625': 'w-e-0.625',
    '0.75': 'w-e-0.75',
    '0.875': 'w-e-0.875',
    '1.0': 'w-e-1.0',
    '1.125': 'w-e-1.125',
    '1.25': 'w-e-1.25',
    '1.375': 'w-e-1.375',
    '1.5': 'w-e-1.5',
    '1.75': 'w-e-1.75',
    '1.875': 'w-e-1.875',
    '2.0': 'w-e-2.0',
    '2.25': 'w-e-2.25',
    '2.375': 'w-e-2.375',
    '2.5': 'w-e-2.5',
    full: 'w-full'
  },
  height: {
    xs: 'h-2',
    sm: 'h-3',
    md: 'h-4',
    lg: 'h-8',
    xl: 'h-9',
    '0.25': 'h-e-0.25',
    '0.5': 'h-e-0.5',
    '0.625': 'h-e-0.625',
    '0.75': 'h-e-0.75',
    '0.875': 'h-e-0.875',
    '1.0': 'h-e-1.0',
    '1.125': 'h-e-1.125',
    '1.25': 'h-e-1.25',
    '1.375': 'h-e-1.375',
    '1.5': 'h-e-1.5',
    '1.75': 'h-e-1.75',
    '1.875': 'h-e-1.875',
    '2.0': 'h-e-2.0',
    '2.25': 'h-e-2.25',
    '2.375': 'h-e-2.375',
    '2.5': 'h-e-2.5',
    full: 'h-full'
  }
});
var sizeOptions$1 = sizeOptions;

export { sizeOptions$1 as default };
//# sourceMappingURL=size-options.esm.js.map
